import { merge as _merge } from 'lodash'
import zh from 'core/translations/zh'

export default _merge(zh, {
  serverError: {
    INVALID_SERIAL: '代碼無效：必須為18位數字。',
    PRODUCTION_ORDER_NOT_FOUND: '找不到此代碼對應的生產訂單。',
    STYLE_MATERIAL_COLOR_MISMATCH: '商品的型號、部件或顏色與生產訂單行不符。',
    SCONNECT_SHIPMENT_FAILED: '向S-Connect傳送出貨失敗。'
  },
  otb_outbound: {
    scan_title: '掃描生產訂單代碼（18位）',
    scan_code_label: '代碼',
    select_title: '選擇生產訂單',
    header_label: '生產訂單',
    pdf_title: 'PDF標籤',
    pdf_downloaded: '包裹標籤已下載',
    pdf_error: '無法生成或下載PDF標籤',
    pdf_parcel_unavailable: '包裹已確認，但無法取得以下載PDF標籤'
  }
})
